<div class="showdrop">
    <div class="loading-notfound" *ngIf="loader">
        <hr class="custom-hr">
        <div class="loader"></div>
        <p>Please wait while we load your assets. </p>&nbsp;
    </div>

    <div class="loading-notfound mb-3"
        *ngIf="!loader && searchData?.logs?.length == 0 && searchData?.collections?.length == 0 && searchData?.nfts?.length == 0 && searchData?.users?.length == 0 && searchData?.user_holdings?.length == 0">
        <img src="https://static.zohocdn.com/chat/source/officechat/images/default/emptystate/search_empty.svg" alt=""
            width="100" height="75" class="mb-3">
        <div>
            <p>No results</p>
            <p>Tinker with a word or two and try again.</p>
        </div>
    </div>

    <div *ngIf="!loader">
        <ng-container *ngIf="searchData?.logs?.length > 0">
            <h3>Dashboard</h3>
            <ng-container *ngFor="let data of searchData?.logs">
                <div class="common-space cursor-pointer" (click)="clickResetSearch()"
                    [routerLink]="['/dashboard/transaction-detail', data?._id]">

                    <div class="common-wrap mb-14">
                        <div class="common-img">
                            <img src="assets/images/icon/Dashboard.svg" alt="wallet" width="18" height="18">
                        </div>
                        <h4>
                            <ng-container *ngFor="let part of getHighlightParts(data?.matching_field['value'], searchKey)">
                                <b *ngIf="part.bold">{{ part.text }}</b>
                                <span *ngIf="!part.bold">{{ part.text }}</span>
                            </ng-container>
                        </h4>
                    </div>
                    <div>
                        <a><img src="assets/images/external-search.svg" alt=""></a>
                    </div>
                </div>
            </ng-container>
            <div class="seemore-btn">
                <button *ngIf="!loadingStates.log && canShowSeeMore['log']"
                    (click)="handleSeeMore(searchType.log);$event.stopPropagation()">See
                    More</button>
                <div *ngIf="loadingStates.log" class="loading-text">Loading...</div>
            </div>
        </ng-container>

        <ng-container *ngIf="searchData?.collections?.length > 0">
            <hr>
            <h3>Manage Collections</h3>
            <ng-container *ngFor="let data of searchData?.collections">
                <div class="common-space mb-14 cursor-pointer" (click)="clickResetSearch()"
                    [routerLink]="['/manage-collection', data?.collection_address]">
                    <div class="common-wrap">
                        <div class="common-img">
                            <img src="assets/images/icon/Manageassets.svg" alt="wallet" width="18" height="18">
                        </div>
                        <h4>
                            <ng-container *ngFor="let part of getHighlightParts(data?.matching_field['value'], searchKey)">
                                <b *ngIf="part.bold">{{ part.text }}</b>
                                <span *ngIf="!part.bold">{{ part.text }}</span>
                            </ng-container>
                        </h4>
                    </div>
                </div>
            </ng-container>
            <div class="seemore-btn">
                <button *ngIf="!loadingStates.collection && canShowSeeMore['collection']"
                    (click)="handleSeeMore(searchType.collection);$event.stopPropagation()">See More</button>
                <div *ngIf="loadingStates.collection" class="loading-text">Loading...</div>
            </div>
        </ng-container>

        <ng-container *ngIf="searchData?.nfts?.length > 0">
            <hr>
            <h3>Manage NFT</h3>
            <ng-container *ngFor="let data of searchData?.nfts">
                <div class="common-space mb-14 cursor-pointer" (click)="clickResetSearch()"
                    [routerLink]="['/manage-nft/edit-nft',data?.collections?.collection_address, data?.token_id]">
                    <div class="common-wrap">
                        <div class="common-img">
                            <img src="assets/images/icon/ManageNft.svg" alt="wallet" width="18" height="18">
                        </div>
                        <h4>
                            <ng-container *ngFor="let part of getHighlightParts(data?.matching_field['value'], searchKey)">
                                <b *ngIf="part.bold">{{ part.text }}</b>
                                <span *ngIf="!part.bold">{{ part.text }}</span>
                            </ng-container>
                        </h4>
                    </div>
                    <div>
                        <a><img src="assets/images/external-search.svg" alt=""></a>
                    </div>
                </div>
            </ng-container>
            <div class="seemore-btn">
                <button *ngIf="!loadingStates.nft && canShowSeeMore['nft']"
                    (click)="handleSeeMore(searchType.nft);$event.stopPropagation()">See
                    More</button>
                <div *ngIf="loadingStates.nft" class="loading-text">Loading...</div>
            </div>
        </ng-container>

        <ng-container *ngIf="searchData?.users?.length > 0">
            <hr>
            <h3>Manage Users</h3>
            <ng-container *ngFor="let data of searchData?.users">
                <div class="common-space mb-14 cursor-pointer" (click)="clickResetSearch()"
                    [routerLink]="['manage-user/user-profile', data?.wallet_address]">
                    <div class="common-wrap">
                        <div class="common-img">
                            <img src="assets/images/icon/Manageusers.svg" alt="wallet" width="18" height="18">
                        </div>
                        <h4>
                            <ng-container *ngFor="let part of getHighlightParts(data?.matching_field['value'], searchKey)">
                                <b *ngIf="part.bold">{{ part.text }}</b>
                                <span *ngIf="!part.bold">{{ part.text }}</span>
                            </ng-container>
                        </h4>
                    </div>
                </div>
            </ng-container>
            <div class="seemore-btn">
                <button *ngIf="!loadingStates.user && canShowSeeMore['user'] "
                    (click)="handleSeeMore(searchType.user);$event.stopPropagation()">See
                    More</button>
                <div *ngIf="loadingStates.user" class="loading-text">Loading...</div>
            </div>
        </ng-container>

        <ng-container *ngIf="searchData?.user_holdings?.length > 0">
            <hr>
            <h3>Users Holdings</h3>
            <ng-container *ngFor="let data of searchData?.user_holdings">
                <a class="common-space mb-14 cursor-pointer" (click)="clickResetSearch()"
                    [href]="data?.lazy_mint ? marketPlaceUrl+'lazy-mint/'+data?._id: marketPlaceUrl+'nft-detail/'+data?.collections?.collection_address+'/'+data?.token_id"
                    target="_blank" rel="noopener noreferrer">
                    <div class="common-wrap">
                        <div class="common-img">
                            <img src="assets/images/icon/Manageusers.svg" alt="wallet" width="18" height="18">
                        </div>
                        <h4>
                            <ng-container *ngFor="let part of getHighlightParts(data?.matching_field['value'], searchKey)">
                                <b *ngIf="part.bold">{{ part.text }}</b>
                                <span *ngIf="!part.bold">{{ part.text }}</span>
                            </ng-container>
                        </h4>
                    </div>
                    <div>
                        <a><img src="assets/images/external-search.svg" alt=""></a>
                    </div>
                </a>
            </ng-container>
            <div class="seemore-btn">
                <button *ngIf="!loadingStates.holding && canShowSeeMore['holding']"
                    (click)="handleSeeMore(searchType.holding);$event.stopPropagation()" class="seemore-btn">See
                    More</button>
                <div *ngIf="loadingStates.holding" class="loading-text">Loading...</div>
            </div>
        </ng-container>
    </div>
</div>
